import { PicLeftOutlined } from '@ant-design/icons'

import { queryLinkInfoApi } from '@eastcoal/api/nexus/link/queryLinkInfo'

import { pick } from '@eastcoal/common/utils/object'
import { isHttpUrl } from '@eastcoal/common/utils/url'

import linkDefaultIcon from '../../../../images/linkDefaultIcon.png'
import { MenuButton } from '../../../MenuButton'
import { useLinkCardStore } from '../../Store/hooks/useStore'

export const SwitchTitleButton = () => {
  const { url, icon, syncFormData, updateLinkNode, toggleToolbarVisible } =
    useLinkCardStore(state =>
      pick(state, [
        'url',
        'text',
        'icon',
        'syncFormData',
        'updateLinkNode',
        'toggleToolbarVisible'
      ])
    )

  const handleShowTitle = async () => {
    toggleToolbarVisible(false)

    if (!url) {
      return
    }

    const res = await queryLinkInfoApi({ url })

    syncFormData({
      text: res.title,
      url: res.url,
      icon: res.icon ?? linkDefaultIcon
    })

    updateLinkNode()
  }

  return (
    <MenuButton
      disabled={!isHttpUrl(url) || !!icon}
      tooltip='显示标题'
      onClick={handleShowTitle}
    >
      <PicLeftOutlined />
    </MenuButton>
  )
}
